import { createContext, useContext, type ReactNode } from 'react';
import { useNotifications } from '@/hooks/useNotifications';

// UI-HEADER-FIXO (I.160): uma fonte só de notificações para o painel. O hook abre a escuta em tempo real; com o
// cliente instalado, dois usos dividem o mesmo canal e o que sai da tela derruba o outro. Menu lateral, sino e Caixa de
// Entrada leem daqui; o hook não muda.
type NotificationsValue = ReturnType<typeof useNotifications>;

const NotificationsContext = createContext<NotificationsValue | null>(null);

export const NotificationsProvider = ({ children }: { children: ReactNode }) => {
  const value = useNotifications();
  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>;
};

export const useNotificationsContext = (): NotificationsValue => {
  const ctx = useContext(NotificationsContext);
  if (!ctx) {
    throw new Error('useNotificationsContext precisa estar dentro de NotificationsProvider');
  }
  return ctx;
};
